import { render } from "./master-partner-program.vue?vue&type=template&id=2a943cc8"
import script from "./master-partner-program.js?vue&type=script&lang=js&external"
export * from "./master-partner-program.js?vue&type=script&lang=js&external"

import "./master-partner-program.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__